import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalVariable } from '../global';
import { ServerService } from '../providers/server.service';

@Component({
  selector: 'app-blog-list',
  templateUrl: './blog-list.page.html',
  styleUrls: ['./blog-list.page.scss'],
})
export class BlogListPage implements OnInit {
  blogs=[]
  isDataLoaded=false;
  constructor(
    private router:Router,
    private server:ServerService,
    public globals:GlobalVariable
  ) { 
    this.getBlogs();
  }

  ngOnInit() {
  }


  navigate(blog){
    let id=blog.id
    let name=blog.title;
    if(!name){
      name="Title not set"
    }
    // name = name.replace(/[^a-zA-Z ]/g, '');
    name = name.replace(/ /g, '-');
    name = name.replace(/--/g, '-');

    this.router.navigateByUrl('blog/' + id+'/'+name, {
      state: { blog: blog },
    });
  }
  close(){
    this.router.navigateByUrl('home',{replaceUrl:true})
  }
  refreshList(event){
    // console.log(event)
    setTimeout(() => {
    this.getBlogs();
    
      event.target.complete();
    }, 2000);
    
  }
  getBlogs() {
  
    this.server.getBlogs().subscribe(
      
      (res) => {
        this.isDataLoaded=true;
    

        console.log(res);
        if (res.status) {
         

          this.blogs=res.data;
        }
      
      },
      (err) => {
        this.isDataLoaded=true;
        this.globals.presentToast('Network error');
      }
    );
  
  }

}
